import { render, staticRenderFns } from "./swiper-pagination-tertiary.vue?vue&type=template&id=4af64c1f&scoped=true&"
import script from "./swiper-pagination-tertiary.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af64c1f",
  null
  
)

export default component.exports